/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Password_Empty_HintInputs */

const vi_grower_camera_settings_password_empty_hint = /** @type {(inputs: Grower_Camera_Settings_Password_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có mật khẩu nào được lưu.`)
};

/**

* @param {Grower_Camera_Settings_Password_Empty_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_password_empty_hint = /** @type {((inputs?: Grower_Camera_Settings_Password_Empty_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Password_Empty_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_password_empty_hint(inputs)
});